import * as actionTypes from "./actionTypes";

// Attaching a screenshot to an action
export function attachmentUploadFail(message) {
  return {
    type: actionTypes.ATTACHMENT_UPLOAD_FAIL,
    message,
  };
}

export function attachmentUploadSuccess(url) {
  return {
    type: actionTypes.ATTACHMENT_UPLOAD_SUCCESS,
    url,
  };
}

export function loadRules() {
  return {
    type: actionTypes.LOAD_RULES,
  };
}

export function loadRulesRequestChain(token) {
  return {
    types: [
      actionTypes.LOAD_RULES_REQUEST,
      actionTypes.LOAD_RULES_REQUEST_SUCCESS,
      actionTypes.LOAD_RULES_REQUEST_FAIL,
    ],
    promise: (client) =>
      client.get("/issues/spark-types", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
  };
}

/**
 * Load comments for the given action
 * @param {string} actionId
 * @param {string} token
 */
export function loadCommentsRequestChain(actionId, token) {
  return {
    types: [
      actionTypes.LOAD_COMMENTS_REQUEST,
      actionTypes.LOAD_COMMENTS_REQUEST_SUCCESS,
      actionTypes.LOAD_COMMENTS_REQUEST_FAIL,
    ],
    promise: (client) =>
      client.get(`/comments/${actionId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
  };
}

/**
 * Load an action from an id
 * @param {string} actionId
 */
export function loadAction(actionId) {
  return {
    type: actionTypes.LOAD_ACTION,
    actionId,
  };
}

/**
 * Load an action and rules list from an action id
 * @param {string} actionId
 */
export function loadActionForEditing(actionId) {
  return {
    type: actionTypes.LOAD_ACTION_FOR_EDITING,
    actionId,
  };
}

export function loadActionRequestChain(actionId, token) {
  return {
    types: [
      actionTypes.LOAD_ACTION_REQUEST,
      actionTypes.LOAD_ACTION_REQUEST_SUCCESS,
      actionTypes.LOAD_ACTION_REQUEST_FAIL,
    ],
    promise: (client) =>
      client.get(`/issue/${actionId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
  };
}

export function actionNotFound() {
  return {
    type: actionTypes.ACTION_NOT_FOUND,
  };
}

// Saving an action to Jira
export function saveAction(action, equipList) {
  return {
    type: actionTypes.SAVE_ACTION,
    equipList,
    action,
  };
}

export function saveActionRequestChain(actionId, action, token) {
  return {
    types: [
      actionTypes.SAVE_ACTION_REQUEST,
      actionTypes.SAVE_ACTION_REQUEST_SUCCESS,
      actionTypes.SAVE_ACTION_REQUEST_FAIL,
    ],
    promise: (client) =>
      client.post(`/issue/${actionId}/edit`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: action,
      }),
  };
}

// Creating a new action in Jira
export function addAction(action, equipList) {
  return {
    type: actionTypes.ADD_ACTION,
    action,
    equipList,
  };
}

export function addActionRequestChain(action, token) {
  return {
    types: [
      actionTypes.ADD_ACTION_REQUEST,
      actionTypes.ADD_ACTION_REQUEST_SUCCESS,
      actionTypes.ADD_ACTION_REQUEST_FAIL,
    ],
    promise: (client) =>
      client.post("/issue", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: action,
      }),
  };
}
